
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';
@Component
export class FinanceOperationsTableMix extends Vue {
    get columns(): ITableColumn[] {
        return [
            {
                title: '№',
                dataIndex: 'id',
                key: '0',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата"),
                dataIndex: 'date',
                key: '1',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'date',
                },
            },
            {
                title: i18nText("Получатель"),
                dataIndex: 'target',
                key: '2',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'target',
                },
            },
            {
                title: i18nText("Назначение"),
                dataIndex: 'type_name',
                key: '3',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Касса"),
                dataIndex: 'cashbox_name',
                key: '4',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Комментарий"),
                dataIndex: 'comment',
                key: '5',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Автор"),
                dataIndex: 'author[name]',
                key: '6',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Сумма"),
                dataIndex: 'sum',
                key: '7',
                scopedSlots: {
                    customRender: 'sum',
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Остаток"),
                dataIndex: 'cashbox_remainder',
                key: '8',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'remainder',
                },
            },
            {
                title: i18nText("Визит"),
                dataIndex: 'visit[date]',
                key: '9',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: 'visit',
                },
            },
        ];
    }
}
